import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthBoxContainer } from '@/components/AuthBox';
import { CircularProgress } from '@mui/material';

export const SPINNER_ID = 'loading-spinner';

export const Oauth2SignoutPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/signin');
  }, [navigate]);

  return (
    <AuthBoxContainer>
      <CircularProgress size={24} sx={{ color: 'white' }} data-testid={SPINNER_ID} />
    </AuthBoxContainer>
  );
};
